import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Map from '../../../map/Map';
import { getImpactLitters, isMapFilterRequested } from '../selectors';
import LoadingComponent from '../../../common/LoadingComponent';

function ImpactMap({ data, isLitterLoading }) {
    const loader = <LoadingComponent isLoading={isLitterLoading} />;
    return isLitterLoading ? (
        <div className="mapLoader">{loader}</div>
    ) : (
        <Map
            isLoading={isLitterLoading}
            dataPoints={data}
            options={{
                streetViewControl: false,
                mapTypeControl: false,
            }}
        />
    );
}

ImpactMap.propTypes = {
    data: PropTypes.arrayOf(PropTypes.object).isRequired,
    isLitterLoading: PropTypes.bool,
};

ImpactMap.defaultProps = {
    isLitterLoading: false,
};

const mapStateToProps = (state) => {
    return {
        data: getImpactLitters(state),
        isLitterLoading: isMapFilterRequested(state),
    };
};

const ConnectedMap = connect(mapStateToProps, null)(ImpactMap);

export default ConnectedMap;
